module.exports = __webpack_public_path__ + "static/media/kijiji.ec3ecfdd.svg";